export default function* callSequence(sagas) {
  let result = [];
  for (let i = 0; i < sagas.length; i += 1) {
    const partial = yield sagas[i];
    result = [...result, partial];
  }

  return result;
}
